import React from 'react';
import PropTypes from 'prop-types';

const allLanguages = require('../data/languages.json')

//Needed
window.Teral = {
    setSourceLanguage : () => {},
}

if(Array.prototype.equals)
    console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function (array) {
    // if the other array is a falsy value, return
    if (!array)
        return false;

    // compare lengths - can save a lot of time
    if (this.length != array.length)
        return false;

    for (var i = 0, l=this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // recurse into the nested arrays
            if (!this[i].equals(array[i]))
                return false;
        }
        else if (this[i] != array[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
}
// Hide method from for-in loops
Object.defineProperty(Array.prototype, "equals", {enumerable: false});

export default class SwitcherPreview extends React.Component {

    switcherId = "tl-switcher-container"

    componentDidMount () {
        this.loadSwitcher()
    }

    componentDidUpdate(prevPros) {
        this.loadSwitcher()
    }

    shouldComponentUpdate(nextProps, nextState) {

        const didSourceLanguageChange = this.props.sourceLanguage == nextProps.sourceLanguage ? false : true;
        const didTargetLanguagesChange = this.props.targetLanguages.equals(nextProps.targetLanguages) ? false : true;
        const didAddFlagsChange = this.props.addFlags == nextProps.addFlags ? false : true;
        const didButtonSettingsChange = JSON.stringify(this.props.buttonSettings) == JSON.stringify(nextProps.buttonSettings);

        if(didSourceLanguageChange || didTargetLanguagesChange || didAddFlagsChange || didButtonSettingsChange)
            return true;
        else
            return false
    }

    loadSwitcher() {
        const containerId = this.switcherId

        const containerElmnt =document.getElementById(containerId)

        //Remove everything first
        if(containerElmnt)
            containerElmnt.innerHTML = ""

        const  { apiKey, cdnHost, sourceLanguage, targetLanguages, addFlags, buttonType } = this.props

        //Make sure they are present first
        if(!sourceLanguage || sourceLanguage.length < 1 || !targetLanguages || targetLanguages.length < 1)
            return

        const buttonSettings = {
            buttonType : buttonType
        }

        const script = document.createElement("script");

        script.src = "//" + cdnHost + "/js/wordpress.min.js";

        script.async = true;
        script.onload = () => {

            window.Teral.init({
                 "apiKey" : apiKey,
                 "sourceLanguage" : sourceLanguage,
                 "targetLanguages" : targetLanguages,
                 "buttonSettings" : buttonSettings,
                 "containerId" : containerId,
                 "preview" : true,
                 "addFlags" : addFlags
             })
        }

        document.body.appendChild(script);
    }

    render() {

        const containerId = this.switcherId

        return ( // The returned markup uses the standard WordPress notice classes. The resulting notice class and message will depend on the contents of the 'notice' prop object, passed down from Admin.jsx.
          <div>
            <div id={containerId}></div>
          </div>
        );
    }
}

SwitcherPreview.defaultProps = { // Here we set default values for some of our props
    buttonType: "dropdown",
    addFlag : true,
    sourceLanguage : "",
    targetLanguages : []
};

SwitcherPreview.propTypes = { // And define our propTypes
    type: PropTypes.string,
    addFlag : PropTypes.bool,
    sourceLanguage : PropTypes.string,
    targetLanguages : PropTypes.array
};
